type Response = { did_you_mean: string | null };

export const fetchEmailSuggestion = async (email: string): Promise<string | null> => {
  const host = (window as Window & { ENV?: { EMAIL_ADDRESS_VALIDATOR_HOST?: string } }).ENV
    ?.EMAIL_ADDRESS_VALIDATOR_HOST;
  if (!host) return null;

  const url = new URL(`https://${host}/address/validate`);
  url.searchParams.append("address", email);

  const response = await fetch(url.toString());
  if (response.status < 200 || response.status >= 300) return null;

  const { did_you_mean: suggestion } = (await response.json()) as Response;
  return suggestion;
};
